import * as React from "react";

function EcomSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30.04}
      height={32.477}
      {...props}
    >
      <path
        d="M21.705 16.95l-.558-9.547h-4.5v4.287h-1.9V7.403H7.413v4.287h-1.9V7.403h-4.5l-1 17.118A4.8 4.8 0 004.804 29.6h10.55a8.774 8.774 0 016.35-12.65zM7.414 5.567a3.664 3.664 0 017.329 0V7.4h1.9V5.567a5.567 5.567 0 00-11.135 0V7.4h1.9z"
        fill="#ff7b16"
      />
      <path
        d="M30.04 25.604a6.873 6.873 0 10-6.873 6.873 6.881 6.881 0 006.873-6.873zm-7.9 3.366l-3.091-3.5 1.426-1.26 1.724 1.957 3.575-3.7 1.369 1.322z"
        fill="#ff7b16"
      />
    </svg>
  );
}

export default EcomSvg;
